var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group q-pb-sm"},[_c('div',{staticClass:"title text-bold text-uppercase",attrs:{"id":_vm.id}},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('div',{staticClass:"list"},_vm._l((_vm.items),function(each){
var _obj;
return _c(_vm.item,_vm._b({key:each.id,tag:"component"},'component',( _obj = {}, _obj[_vm.prop] = each, _obj ),false))}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }